/* @ngInject */
const dispatch = (
  dispatchAsk,
  dispatchFormat,
  dispatchGo,
  dispatchLocal,
  dispatchMetadata,
  dispatchRequest,
  dispatchData,
  dispatchNew
) => {
  const self = {}

  self.new = dispatchNew
  self.ask = dispatchAsk
  self.format = dispatchFormat
  self.go = dispatchGo
  self.local = dispatchLocal
  self.metadata = dispatchMetadata
  self.data = dispatchData
  self.request = dispatchRequest

  return self
}

export default dispatch



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/dispatch/services/dispatch.service.js